(function() {
  'use strict';

  angular.module('eclipseApp.core').directive('convertLocalTimeZone', ['$filter', 'uteLocale', 'timeZoneMappingConstants',  function ($filter, uteLocale, timeZoneMappingConstants) {
    return {
      restrict: 'AE',
      replace: true,
      scope: {
        province: '=province',
        date: '=date'
      },
      template: '<span>{{localDate}}&nbsp;{{timeZone}}</span>',
      link: function ($scope, $element, $attr) {

        $scope.fetchTimeZoneOffset = function(dst){
          var conversionOffset = '';
          if(angular.isUndefined($scope.province)){
            $scope.province = "ON"; //default set EST time if province is not sent
          }
          if(dst){
            $scope.timeZone = timeZoneMappingConstants[$scope.province.toUpperCase()].dstTimeZone;
            conversionOffset = timeZoneMappingConstants[$scope.province.toUpperCase()].dstOffset;
          }else{
            $scope.timeZone = timeZoneMappingConstants[$scope.province.toUpperCase()].stdTimeZone;
            conversionOffset = timeZoneMappingConstants[$scope.province.toUpperCase()].stdOffset;
          }
          return conversionOffset;
        };

        var date = new Date($scope.date);
        var offset= '';
        if(moment(date).isDST()){
          offset = $scope.fetchTimeZoneOffset(true);
        }else{
          offset = $scope.fetchTimeZoneOffset(false);
        }
        var utcTime = date.getTime() + (date.getTimezoneOffset() * 60000);


        if(uteLocale.language == 'en'){
          $scope.localDate = $filter('date')(new Date(utcTime + (3600000*offset)), 'MMMM dd, yyyy hh:mma');
        }else{
          $scope.localDate = $filter('date')(new Date(utcTime + (3600000*offset)), 'dd MMMM yyyy hh:mma');
        }
      }
    };
  }]);
})();
